module.exports = __webpack_public_path__ + "img/index.8755e7a4.webp";